import React, { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';

export default function StickyMobileBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToPricing = () => {
    document.querySelector('#pricing')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div
      className={`md:hidden fixed bottom-0 left-0 right-0 z-40 transition-transform duration-300 ${
        visible ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      <div className="mx-3 mb-3 rounded-xl bg-[#0f1725]/95 backdrop-blur border border-white/10 shadow-2xl px-3 py-2.5 flex items-center gap-3">
        <div className="flex-1 min-w-0">
          <div className="text-white text-xs font-semibold leading-tight">
            Starts at{' '}
            <span className="text-emerald-400 text-base font-extrabold">&#8377;499</span>
            <span className="text-slate-500 line-through ml-1.5 text-[11px]">&#8377;1499</span>
          </div>
          <div className="text-[10.5px] text-slate-400 leading-tight mt-0.5">
            67% OFF &middot; Only 23 slots left today
          </div>
        </div>
        <button
          onClick={scrollToPricing}
          className="inline-flex items-center gap-1.5 bg-emerald-500 hover:bg-emerald-400 text-slate-900 font-bold px-4 py-2.5 rounded-lg text-sm shadow-lg shadow-emerald-500/25 whitespace-nowrap"
        >
          Get Started <ArrowRight size={14} />
        </button>
      </div>
    </div>
  );
}
